var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.517,10.992a12.624,12.624,0,0,0,5.492,5.492l1.833-1.833a.829.829,0,0,1,.85-.2,9.506,9.506,0,0,0,2.975.475.836.836,0,0,1,.833.833v2.908a.836.836,0,0,1-.833.833A14.165,14.165,0,0,1,4.5,5.333.836.836,0,0,1,5.333,4.5H8.25a.836.836,0,0,1,.833.833,9.467,9.467,0,0,0,.475,2.975.836.836,0,0,1-.208.85Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#FF5C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOrange);
export default __webpack_public_path__ + "static/media/phone_orange.1b10db1b2a30b7c9ec9fe294024c6d76.svg";
export { ForwardRef as ReactComponent };